
// Vue
import { Prop } from 'vue-property-decorator';
import { Component, Mixins } from 'vue-mixin-decorator';
// Const
import { RouteConsts } from '@/routes/route';
// Components
import BasePage from '@/pages/BasePage.vue';
import { ProductAllOfSwagger } from '@/apis/cms';

/**
 * [SFR0007] 商品詳細 - 料金タブコンポーネント
 */
@Component
export default class ProductDetailPrice extends Mixins<BasePage>(BasePage) {
  /** プロダクト名 */
  @Prop({ default: '' })
  productName!: string;
  /** プラン名 */
  @Prop({ default: '' })
  planName!: string;
  /** プラン説明 */
  @Prop({ default: '' })
  planDescription!: string;
  /** 利用規約区分 */
  @Prop({ default: '' })
  tosType!: string;
  /** 利用規約 HTMLコンテンツ */
  @Prop({ default: '' })
  tosText!: string;
  /** 利用規約 PDFコンテンツ */
  @Prop({ default: '' })
  tosPdf!: string;
  /** 料金プラン ファイルコンテンツ */
  @Prop({ default: undefined })
  plansFile!: ProductAllOfSwagger;

  /**
   * 商品説明の金額部分と説明部分を分割し、返り値とする
   */
  private getPlanDescription() {
    if (this.planDescription == undefined) {
      return {
        price: '',
        unit: '',
        description: ''
      };
    }
    const strArr = this.planDescription.split('\n');
    const price = strArr.length > 0 ? strArr[0] : '';
    const unit = strArr.length > 1 ? strArr[1] : '';
    const desc = this.planDescription.slice(
      price.length + unit.length + 2, // 改行コード２つ分考慮
      this.planDescription.length
    );
    return {
      price: price,
      unit: unit,
      description: desc
    };
  }

  // お問い合わせ画面遷移
  private goToSupportPage() {
    const queryTYpeLabels: any = this.$t('pages.supportPage.label.select');
    this.$router.push({
      name: RouteConsts.SupportPage,
      params: {
        queryType: queryTYpeLabels['aboutPurchaceOrCancel'],
        queryBody: this.productName + ' のお問い合わせ'
      }
    });
  }
}
